import React from 'react'
import CommonHeader from './common/CommonHeader'
import '../torfacts.css'
import Footer from './common/Footer'
import KnowMore from './common/KnowMore';
import Announcement from "../../assets/images/releases.png"
import './Releases.css'


const Releases = () => {
  return (
    <>
      <div className="main-content">
        <CommonHeader title={'Releases'} id={'4'} />
      </div>
      <div className='pageContent bg-light-blue'>
        <div className="main-content">
          <img src={Announcement} className='announcement' />
          <h2 className='question-title text-center mt-8'>Features of Torfacts release 2.1 updated on 2nd.Jan.2019</h2>
          <div className='releases-content'>
            <div className='releases-content-arrow'></div>
              <h2 className='question-title'><i>Promo Code feature</i></h2>
              <p className='page-content'> On popular demand, Torfacts brings Promo Codes for its panelists every week. Quick way to grab more 
rewards.</p>
                <hr className='releases-separator' />

                <h2 className='question-title'><i>Refer Friend</i></h2>
              <p className='page-content'>Get your friends associated with Torfacts and grab exciting rewards. Look out for Refer Friend option 
in your account.</p>
          </div>

          <h2 className='question-title text-center mt-8'> Features of Torfacts release 2.0 updated on 1st.Dec.2018</h2>
          <div className='releases-content'>
            <div className='releases-content-arrow'></div>
              <h2 className='question-title'><i> Torfcats now supports multiple languages</i></h2>
              <p className='page-content'>You can walk thourgh the site with much more ease now as Torfacts is available in your preffered language.</p>

              <table className='language-releases'>
                <tr>
                  <td>English</td>
                  <td>Indonesian</td>
                  <td>Italian</td>
                  <td>Japanese</td>
                </tr>
                <tr>
                  <td>Korean</td>
                  <td>Malay</td>
                  <td>Dutch</td>
                  <td>Polish</td>
                </tr>
                <tr>
                  <td>Portuguese</td>
                  <td>Thai</td>
                  <td>Vietnamese</td>
                  <td>German</td>
                </tr>
                <tr>
                  <td>Turkish</td>
                  <td>Spanish</td>
                  <td>Filipino</td>
                  <td>French</td>
                </tr>
              </table>
                
              <hr className='releases-separator' />

              <h2 className='question-title'><i>Earn more with our new point system</i></h2>
              <p className='page-content'>The new Torfacts accumulates points into your account. These points hold a much higher value and are easy to earn and redeem. With multiple redeem options to select from, we are sure you'll enjoy the survey taking experience.</p>

              <hr className='releases-separator' />

              <h2 className='question-title'><i>Accumulate points with hassel free redeemption</i></h2>
              <p className='page-content'>You get the benefit of earning the same no. of points, irrespective of the currency you want to redeem them in.</p>

              <hr className='releases-separator' />

              <h2 className='question-title'><i>Survey disqualification is no more a bad news</i></h2>
              <p className='page-content'>You earn points even when you do not qualify for a survey, you started answering.</p>

              <hr className='releases-separator' />

              <h2 className='question-title'><i>New and Improved layout</i></h2>
              <p className='page-content'>The fresh look of Torfacts will make you fall in love with it. It is now much easier to use and would be a great experience for you.</p>

              <hr className='releases-separator' />

              <h2 className='question-title'><i>What Avatar are you today</i></h2>
              <p className='page-content'>You can now create your own avatar to feature on your dashboard.</p>

              <hr className='releases-separator' />

              <h2 className='question-title'><i>Fresh and Hot surveys on your dashboard</i></h2>
              <p className='page-content'>You don't have to worry about refresing your dashboard to view new surveys, we'll keep your dashboard populated with latest surveys automatically.</p>

          </div>

        </div>
      </div>
      <KnowMore />
      <Footer />
    </>
  )
}

export default Releases